//
// users service
//
import authAxios from "../lib/auth_axios";

const converError = (err) => {
  console.log(err);
  // handle proper display of message for 403, Forbidden which does not return an object
  if (err.response.status === 403) return new Error(err);

  return err.response && err.response.data && err.response.data.message
    ? err.response.data
    : err;
};

const deleteUser = (user) => {
  return new Promise(async (resolve, reject) => {
    const url = `/api/users/${user._id}`;
    try {
      const { data } = await authAxios.delete(url);
      resolve(data);
    } catch (err) {
      reject(converError(err));
    }
  });
};

const updateOrCreateUser = (user) => {
  let response;
  return new Promise(async (resolve, reject) => {
    try {
      const id = user._id;
      if (id) {
        // update
        const url = `/api/users/${id}`;
        response = await authAxios.put(url, user);
      } else {
        // create
        const url = `/api/users`;
        response = await authAxios.post(url, user);
      }
      resolve(response.data);
    } catch (err) {
      reject(converError(err));
    }
  });
};
const updateCurrentUser = (user) => {
  let response;
  return new Promise(async (resolve, reject) => {
    try {
        const url = `/api/current_user/`;
        response = await authAxios.put(url, user);
      resolve(response.data);
    } catch (err) {
      reject(converError(err));
    }
  });
};

const getCurrentUser = (user) => {
  return new Promise(async (resolve, reject) => {
    const url = `/api/current_user`;
    try {
      const { data } = await authAxios.get(url);
      resolve(data);
    } catch (err) {
      reject(converError(err));
    }
  });
};

const getCurrentBranch = (branch_id) => {
  return new Promise(async (resolve, reject) => {
    const url = `/api/branches/${branch_id}/settings`;
    try {
      const { data } = await authAxios.get(url);
      resolve(data);
    } catch (err) {
      reject(converError(err));
    }
  });
};

const getBranchByID = (branch_id) => {
  return new Promise(async (resolve, reject) => {
    const url = `/api/branches/${branch_id}`;
    try {
      const { data } = await authAxios.get(url);
      resolve(data);
    } catch (err) {
      reject(converError(err));
    }
  });

}

const getCurrentVendor = () => {
  return new Promise(async (resolve, reject) => {
    const url = `/api/current_vendor`;
    try {
      const { data } = await authAxios.get(url);
      resolve(data);
    } catch (err) {
      reject(converError(err));
    }
  });
};

const getCurrentVendorSettings = () => {
  return new Promise(async (resolve, reject) => {
    const url = `/api/current_vendor/settings`;
    try {
      const { data } = await authAxios.get(url);
      resolve(data);
    } catch (err) {
      reject(converError(err));
    }
  });
};

const getBranches = () => {
  return new Promise(async (resolve, reject) => {
    const url = `/api/current_user/branches`;
    try {
      const { data } = await authAxios.get(url);
      resolve(data);
    } catch (err) {
      reject(converError(err));
    }
  });
};

const switchBranch = (branch_id) => {
  return new Promise(async (resolve, reject) => {
    const url = `/api/current_user/switch_branch?branch_id=${branch_id}`;
    try {
      const { data } = await authAxios.put(url);
      resolve(data);
    } catch (err) {
      reject(converError(err));
    }
  });
};

const getTermsOfUseDate = () => {
  return new Promise(async (resolve, reject) => {
    const url = `/system/info/terms_of_use_date`;
    try {
      const { data } = await authAxios.get(url);
      resolve(data);
    } catch (err) {
      reject(converError(err));
    }
  });
};

const acceptTermsOfUse = ({ user_name }) => {
  return new Promise(async (resolve, reject) => {
    const url = `/api/current_vendor`;
    try {
      const values = {
        info: {
          terms_of_use_accepted_at: new Date(),
          terms_of_use_accepted_by: user_name,
        },
      };

      const { data } = await authAxios.put(url, values);
      resolve(data);
    } catch (err) {
      reject(converError(err));
    }
  });
};

const getCurrentSettings = async (activeBranchID) => {
  const vendorSettings = await getCurrentVendor();
  const currentBranchSettings = await getCurrentBranch(activeBranchID)
  return Object.assign(
    {
      ...vendorSettings?.settings, 
      business_type: vendorSettings?.business_type
    }, 
    currentBranchSettings
  )
}


const changeUserStatus = (userId) => {
    return new Promise(async (resolve, reject) => {
      const url = `/api/users/${userId}/status`;
      try {
        const data = await authAxios.patch(url, {status:'D'});
        resolve(data);
      } catch (err) {
        reject(converError(err));
      }
    });
  };

export {
  deleteUser,
  updateOrCreateUser,
  getCurrentUser,
  getCurrentVendor,
  getCurrentVendorSettings,
  getCurrentBranch,
  getBranches,
  switchBranch,
  getCurrentSettings,
  // -- terms of use
  getTermsOfUseDate,
  acceptTermsOfUse,
  getBranchByID,
  updateCurrentUser,
  changeUserStatus
};
